














































import { Activity } from '@/types/activity';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ActivityTimeline extends Vue {
    now: Date = new Date();
    selected = [-1];

    @Prop() private activities!: Activity[];
    @Prop() private isRefreshingData!: boolean;
    @Prop() private isDataLoaded!: boolean;

    get latestActivities() {
        return this.activities.slice(0, 10);
    }

    created() {
        setInterval(() => {
            this.now = new Date();
        }, 1000 * 60); // every 60 seconds
    }
}
